import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { InfoCircle, StatusAlert, StatusComplete, StatusWarning, } from '@wix/wix-ui-icons-common';
import Text from '../Text';
import Button from '../Button';
import CloseButton from '../CloseButton';
import { APPEARANCE, dataHooks, LAYOUT, SIZE, BORDER } from './constants';
import { classes, st } from './SectionHelper.st.css.js';
import { WixDesignSystemContext } from '../WixDesignSystemProvider/context';
const DEFAULT_ICONS = {
    [APPEARANCE.Standard]: React.createElement(InfoCircle, null),
    [APPEARANCE.Success]: React.createElement(StatusComplete, null),
    [APPEARANCE.Warning]: React.createElement(StatusWarning, null),
    [APPEARANCE.Danger]: React.createElement(StatusAlert, null),
    [APPEARANCE.Premium]: React.createElement(InfoCircle, null),
    [APPEARANCE.Preview]: React.createElement(InfoCircle, null),
    [APPEARANCE.ExperimentalDark]: React.createElement(InfoCircle, null),
};
const SectionHelper = ({ dataHook, showCloseButton = false, onClose, onAction, actionText, appearance = APPEARANCE.Warning, title, size = SIZE.Medium, fullWidth = false, children, layout = LAYOUT.Vertical, border = BORDER.Standard, showPrefixIcon = false, prefixIcon, }) => {
    const isExperimentalDark = appearance === APPEARANCE.ExperimentalDark;
    const { newColorsBranding } = useContext(WixDesignSystemContext);
    const icon = showPrefixIcon && (prefixIcon ?? DEFAULT_ICONS[appearance]);
    return (React.createElement("div", { "data-hook": dataHook, "data-appearance": appearance, className: st(classes.root, {
            appearance,
            withCloseBtn: showCloseButton,
            fullWidth,
            size,
            newColorsBranding,
            border,
            hasPrefix: showPrefixIcon,
        }) },
        showCloseButton && (React.createElement("div", { className: st(classes.close, { size }) },
            React.createElement(CloseButton, { dataHook: dataHooks.closeButton, size: "medium", skin: isExperimentalDark ? 'light' : 'dark', onClick: onClose }))),
        icon && (React.createElement(Text, { dataHook: dataHooks.prefix, className: st(classes.prefix), light: isExperimentalDark }, icon)),
        React.createElement("div", { className: st(classes.content, { size, layout }) },
            React.createElement("div", { className: st(classes.textContainer) },
                title && (React.createElement("div", { className: classes.title },
                    React.createElement(Text, { className: classes.text, light: isExperimentalDark, dataHook: dataHooks.title, size: "small", weight: "bold" }, title))),
                React.createElement(Text, { className: classes.text, size: "small", light: isExperimentalDark }, children)),
            actionText && (React.createElement(Button, { className: st(classes.action), size: size === 'small' ? 'tiny' : 'small', skin: isExperimentalDark ? 'standard' : 'dark', priority: isExperimentalDark ? 'primary' : 'secondary', onClick: onAction, dataHook: dataHooks.actionButton }, actionText)))));
};
SectionHelper.displayName = 'SectionHelper';
SectionHelper.propTypes = {
    dataHook: PropTypes.string,
    appearance: PropTypes.oneOf([
        'warning',
        'standard',
        'danger',
        'success',
        'premium',
        'preview',
        'experimentalDark',
    ]),
    title: PropTypes.node,
    size: PropTypes.oneOf(['small', 'medium']),
    showCloseButton: PropTypes.bool,
    onClose: PropTypes.func,
    onAction: PropTypes.func,
    actionText: PropTypes.string,
    children: PropTypes.node,
    fullWidth: PropTypes.bool,
    layout: PropTypes.oneOf(['vertical', 'horizontal']),
    border: PropTypes.oneOf(['standard', 'topBottom']),
    showPrefixIcon: PropTypes.any,
    prefixIcon: PropTypes.any,
};
export default SectionHelper;
//# sourceMappingURL=SectionHelper.js.map